
import {initWebComponent} from "@/helpers/web-component-helper";
import {isVisibleBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {isMobile} from "@/helpers/mobile-helper";
import {isWebsiteOpened, setShowHelp, setWebsiteOpened, showHelp} from "@/helpers/welcome-menu-helper";
import {hideAllInfo, hideIconMenuButtonTitles, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {startTour} from "@/helpers/tour/tour-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper.js";
import {getLegendUrl} from "@/helpers/ol/ol-layer-helper.js";

export class BookmarkInfoComponent extends HTMLElement {
    constructor(){
        super();

        const settings = window.settings

        let showHelpChecked = showHelp()
        let checked = ''

        let innerHTML = ''
        if(settings.WelkomBij) {

            if(showHelpChecked === 'true' || showHelpChecked === undefined) {
                checked = 'checked="checked"'
            }

            innerHTML += `
                <div class="card m-3 bg-lighter" style="border-radius: 10px;">
                     <h2 class="card-header font-weight-bold p-2">
                         ` + settings.WelkomBij + `
                         <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                            <span class="fa fa-times"></span>
                         </button>
                         
                         <label class="switcher float-right">
                            <span class="switcher-label w-100" style="margin-top:1px">
                                Tonen bij opstarten
                            </span>
                            <input type="checkbox" class="switcher-input" ${checked}>
                            <span class="switcher-indicator" data-test="bookmark_info_startup_switch">
                              <span class="switcher-yes">
                                <span class="fa fa-draw-polygon"></span>
                              </span>
                              <span class="switcher-no">
                                <span class="fa fa-times"></span>
                              </span>
                            </span>
                          </label>
                     </h2>
                     <div class="card-body p-2">
                        ` + settings.WelkomPopup + `
                     </div>
                `

            if(showHelpChecked === 'true' || showHelpChecked === undefined) {
                // if (isMobile()) {
                //     if (!isWebsiteOpened()) {
                //         showElementsBySelector('bookmark-info')
                //         showElementsBySelector('.info-menu-content')
                //         setWebsiteOpened()
                //     }
                // } else {
                    showElementsBySelector('bookmark-info')
                    showElementsBySelector('.info-menu-content')
                // }
            }


            innerHTML += `</div> `
        }

        const welcomeButtons = settings.buttons[1]
        const entries = Object.entries(welcomeButtons)

        if(entries.length > 0) {
            innerHTML += `
                 <div class="card m-3 bg-lighter" style="border-radius: 10px;">
                    <h2 class="card-header font-weight-bold p-2">
                         Help knoppen`

            if(!settings.WelkomBij) {
                innerHTML += `<button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                            <span class="fa fa-times"></span>
                         </button>`
            }

            innerHTML += `</h3>
                    <div class="card-body p-2">`
            for (const [key, value] of entries) {
                innerHTML += `
                <a href="` + value + `" target="_blank" class="d-block mb-3 text-dark">
                    <i class="ion ion-ios-arrow-forward"></i>
                   ` + key + `
                </a>
                `;
            }

            innerHTML += `</div>`
            innerHTML += `</div>`
        }

        if(settings.HelpWalkthroughButtons) {
            innerHTML += generateHelpWalkThrough()
        }

        if(isMobile()) {
            innerHTML += `<div class="card m-3 bg-lighter" style="border-radius: 10px;">`
            innerHTML += `<header-logo></header-logo>`
            innerHTML += `</div>`

            if(isWebsiteOpened()) {
                // hideLayerInfoForm(true, false)
            }
        }

        const template = document.createElement('template');
        template.innerHTML = innerHTML;
        initWebComponent(this, template)

        document.querySelector('bookmark-info').addEventListener('click', (e) => {
            const element = e.target.closest('.startTour')
            if(element) {
                startTour(element.dataset.id, parseInt(element.dataset.step))
            }
        })

        const input = this.querySelector('input')
        if(input) {
            input.addEventListener('change', (e) => {
                if (e.target.checked) {
                    setShowHelp('true')
                } else {
                    setShowHelp('')
                }
            })
        }

        function generateHelpWalkThrough() {
            let innerHTML = ''
            innerHTML += `
                     <div class="card m-3 bg-lighter" style="border-radius: 10px;">
                        <h2 class="card-header font-weight-bold p-2">
                             Help doorloop`


            innerHTML += `<button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                                <span class="fa fa-times"></span>
                             </button>`

            innerHTML += `</h3>
                        <div class="card-body p-2">        
                         <a href="#" class="d-block startTour mb-1 text-dark" data-id="0" data-test="start_full_walkthrough">
                        <i class="ion ion-ios-arrow-forward"></i> Start volledige doorloop
                    </a>   
                    
                    <div class="row mt-3">
                        <div class="col">
                   <h4 class="mb-0 mt-3">
                         <a href="#" class="d-block startTour mb-1 text-dark" data-id="1">
                            <i class="ion ion-ios-arrow-forward"></i> Navigatiebalk
                        </a>   
                    </h4>
                    <a href="#" class="d-block startTour mb-1 text-dark"  data-id="1" data-step="1">
                        <i class="fa fa fa-book"></i> Catalogus
                    </a>   
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="2">
                        <i class="fa fa-home"></i> Pagina herladen
                    </a>
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="3">
                        <i class="fa fa-search"></i> Zoeken naar adres
                    </a>
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="4">
                        <i class="fa fa-filter"></i> Filteren
                    </a>
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="5">
                        <i class="fa fa-external-link-alt"></i> Doorstarten
                    </a>
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="6">
                        <i class="fa fa-file-pdf"></i> Printen
                    </a>
                     <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="7">
                        <i class="fa fa-bell"></i> Meldingen
                    </a>`

                    if (!!getToken()) {
                        innerHTML += `<a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="8">
                                        <i class="fa fa-user"></i> Profiel
                                    </a>`
                    } else {
                        innerHTML += `<a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="8">
                                        <i class="fa fa-sign-in-alt"></i> Inloggen
                                    </a>`
                    }

      innerHTML += `<a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="9">
                        <i class="fa fa-info-circle"></i> Informatie
                    </a>
                    <a href="#" class="d-block mb-1 startTour text-dark"  data-id="1" data-step="10">
                        <i class="fa fa-expand-arrows-alt"></i> Volledig Scherm
                    </a>
                    
                    <h4 class="mb-0 mt-3">
                         <a href="#" class="d-block startTour mb-1 text-dark" data-id="2">
                            <i class="ion ion-ios-arrow-forward"></i> Catalogus
                        </a>   
                    </h4>
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="2" data-step="1">
                        <i class="fa fa-book"></i> Catalogus
                    </a>
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="2" data-step="2">
                        <i class="fa fa-plus"></i> Data importeren
                    </a>`

            if(getToken()) {
                innerHTML += `
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="2" data-step="3">
                        <i class="fa fa-bookmark"></i> Bookmarks
                    </a>`
            }

            innerHTML += `
                    </div>
                        <div class="col">
                           
                    <h4 class="mb-0 mt-3">
                         <a href="#" class="d-block startTour mb-1 text-dark" data-id="3">
                            <i class="ion ion-ios-arrow-forward"></i> Kaart acties
                        </a>   
                    </h4>
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="1">
                        <i class="fa fa-map"></i> Achtergrondkaart
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="2">
                        <i class="fa fa-plus"></i> Inzoomen
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="3">
                        <i class="fa fa-minus"></i> Uitzoomen
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="4">
                        <i class="fa fa-vector-square"></i> Centreren
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="5">
                        <i class="fa fa-location-arrow"></i> Huidige locatie
                    </a>
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="6">
                        <i class="fas fa-arrows-alt-h"></i> Slider
                    </a>`

                    if (getViewProjectionName() === 'EPSG:3857') {
                        innerHTML += `<a href="#" class="d-block startTour mb-1 text-dark" data-id="3" data-step="7">
                                        <i class="fas fa-cube"></i> 3D
                                    </a>`
                    }

      innerHTML += `<h4 class="mb-0 mt-3">
                         <a href="#" class="d-block startTour mb-1 text-dark" data-id="4">
                            <i class="ion ion-ios-arrow-forward"></i> Informatie acties
                        </a>   
                    </h4>
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="1">
                        <i class="fa fa-tag"></i> Kenmerken
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="2">
                        <i class="fa fa-info"></i> Informatie
                    </a>   
                    <a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="3">
                        <i class="fa fa-filter"></i> Filter
                    </a>`

                    if (isVisibleBySelector('layer-info-mutation-button')) {
                        innerHTML += `<a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="4">
                                        <i class="fa fa-edit"></i> Muteren
                                    </a>`
                    } else {
                        innerHTML += `<a href="#" class="d-none startTour mb-1 text-dark" data-id="4" data-step="4">
                                        <i class="fa fa-edit"></i> Muteren
                                    </a>`
                    }

      innerHTML += `<a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="5">
                        <i class="fa fa-pencil-ruler"></i> Tekenen en meten
                    </a>`

                    if (isVisibleBySelector('layer-info-legend-button')) {
                        innerHTML += `<a href="#" class="d-block startTour mb-1 text-dark" data-id="4" data-step="6">
                                        <i class="fa fa-list-ul"></i> Legenda
                                    </a>`
                    } else {
                        innerHTML += `<a href="#" class="d-none startTour mb-1 text-dark" data-id="4" data-step="6">
                                        <i class="fa fa-list-ul"></i> Legenda
                                    </a>`
                    }

    innerHTML += `</div>
        </div>
                    </div>`
            innerHTML += `</div>`

            return innerHTML
        }
    }
}

